import request from '@/utils/request'


// 查询商家地址列表
export function listMerchantAddress(query) {
  return request({
    url: '/biz/admin/merchant/address/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询商家地址分页
export function pageMerchantAddress(query) {
  return request({
    url: '/biz/admin/merchant/address/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询商家地址详细
export function getMerchantAddress(data) {
  return request({
    url: '/biz/admin/merchant/address/detail',
    method: 'post',
    data: data
  })
}

// 新增商家地址
export function addMerchantAddress(data) {
  return request({
    url: '/biz/admin/merchant/address/add',
    method: 'post',
    data: data
  })
}

// 修改商家地址
export function updateMerchantAddress(data) {
  return request({
    url: '/biz/admin/merchant/address/edit',
    method: 'post',
    data: data
  })
}

// 删除商家地址
export function delMerchantAddress(data) {
  return request({
    url: '/biz/admin/merchant/address/delete',
    method: 'post',
    data: data
  })
}
